var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"aside-menu"},[_c('ul',{staticClass:"links"},[_vm._l((_vm.links),function(link,href){return _c('li',{class:!link ? "break" : ""},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(link))])])}),_c('li',{staticClass:"break"}),_c('li',[_c('a',{attrs:{"role":"button"},on:{"click":_vm.logout}},[_vm._v("Log Out")])])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }